import React, { Component } from 'react';
import { removeUnicodeControlCharacters } from './Helper';
import InputField from './InputField';
import SimpleDropdown from './SimpleDropdown';
import { HTMLTrans, withTranslation } from './Translations';

class AddressForm extends Component {
    handleInputChange(v) {
        this.props.onChange(v);
    }

    generateAddressPlaceholder(t, addressLineNum) {
        switch(addressLineNum) {
            case 1: return t("address.addressform_address_addressline1", "PO Box and APO addresses are not deliverable");
            case 2: return t("address.addressform_address_addressline2", "Address Line 2");
            case 3: return t("address.addressform_address_addressline3", "Address Line 3");
            default: return t("address.addressform_address_addressline", "Address line") + ` ${addressLineNum}`;
        }
    }

    generateAddressLabel(t, addressLineNum) {
        switch(addressLineNum) {
            case 1: return t("address.addressform_address_label", "Address");
            case 3: return t("address.addressform_address_label3", " ");
            default: return t(`address.addressform_address_label${addressLineNum}`, " ");
        }
    }

    renderInputfield(props) {
        return (
            <InputField
                key={props.id}
                labelClass='col-md-4 d-none d-lg-block py-2 mb-0'
                inputClass='col-12 col-lg-8'
                {...props}
            />
        );
    }

    render() {
        const {
            id = '',
            first_name = '',
            last_name = '',
            country_name = '',
            country_code = '',
            street1 = '',
            street2 = '',
            street3 = '',
            postcode = '',
            company = '',
            abn = '',
            city = '',
            state = '',
            containerClass = '',
            telephone_number = '',
            showPhoneField = false,
            hiddenPhoneField = false,
            areAddressDetailsValid = true,
            suggestedPostalCodeCombination = null,
            addressValidationErrors = null,
            t
        } = this.props;

        const labelClass = 'col-md-4 d-none d-lg-block py-2 mb-0';
        const address = [street1, street2, street3];
        const required = true;
        const postcodeIsRequired = country_code !== 'VN';
        const showStates = this.props.states ? (this.props.states.length > 0 || false) : false;
        const showCities = this.props.cities ? (this.props.cities.length > 0 || false) : false;
        const hasABN = ['AU'].includes(country_code) === true;
        const hasCityValidationError = addressValidationErrors !== null && typeof addressValidationErrors === 'object'
                             && 'validation_error' in addressValidationErrors && addressValidationErrors['validation_error'] == 'city';
        const postCodeFieldValid = areAddressDetailsValid || hasCityValidationError;
        return (
            <div className={`container ${containerClass}`}>
                {this.renderInputfield({
                    id: `first_name-${id}`,
                    label: t("address.addressform_firstname_label", "First Name"),
                    placeholder: t("address.addressform_firstname_placeholder", "First Name"),
                    value: first_name,
                    maxLength: '30',
                    required,
                    ...!first_name && { invalidFeedback: t("address.addressform_firstname_error", "First name is required.") },
                    onChange: (event) => {
                        this.handleInputChange({ first_name: removeUnicodeControlCharacters(event.target.value) });
                    }
                })}
                {this.renderInputfield({
                    id: `last_name-${id}`,
                    label: t("address.addressform_lastname_label", "Last Name"),
                    placeholder: t("address.addressform_lastname_placeholder", "Last Name"),
                    value: last_name,
                    maxLength: '30',
                    required,
                    ...!last_name && { invalidFeedback: t("address.addressform_lastname_error", "Last name is required.") },
                    onChange: (event) => {
                        this.handleInputChange({ last_name: removeUnicodeControlCharacters(event.target.value) });
                    }
                })}                
                {this.renderInputfield({
                  id: `company-${id}`,
                  label: [t("address.addressform_companyname_label", "Company Name "), <i key={id} className={'text-gray-lighten-1'}>{t("address.addressform_optional_label", "(optional)")}</i>],
                  placeholder: t("address.addressform_companyname_placeholder", "Company Name"),
                  value: company,
                  maxLength: '30',
                  onChange: (event) => {
                    this.handleInputChange({company: removeUnicodeControlCharacters(event.target.value) });
                  }
                })}
                {hasABN &&
                this.renderInputfield({
                  id: `abn-${id}`,
                  label: ['ABN ', <i key={id} className={'text-gray-lighten-1'}>{t("address.addressform_optional_label", "(optional)")}</i>],
                  maxLength: '14',
                  onChange: (event) => {
                    const value = event.target.value.replace(/[\D]/g, '');
                    let abnFormatted = '';
                    const part = [];
                    const format = [2, 3, 3, 3];
                    [0, 2, 5, 8].forEach((v, i) => {
                      if (value.length > v) {
                        part.push(value.substr(v, format[i]));
                      }
                    });
                    part.forEach((v, i) => {
                      abnFormatted += (i > 0 ? ' ' : '') + v;
                    });
                    this.handleInputChange({ abn: abnFormatted });
                  },
                  value: abn,
                })}
                {
                    [1, 2, 3].map((addressLineNum) => {
                        const str = `street${addressLineNum}`;
                        const value = address[addressLineNum - 1];
                        const isRequired = t("address.addressform_address_isrequired", "is required.");
                        const addressLabel = this.generateAddressLabel(t, addressLineNum);
                        const placeholder =  this.generateAddressPlaceholder(t, addressLineNum);
                        return this.renderInputfield({
                            maxLength: 30,
                            id: `${str}-${id}`,
                            label: addressLabel,
                            placeholder,
                            value,
                            ...addressLineNum < 2 && { required },
                            ...!value && addressLineNum < 2 && { invalidFeedback: `${addressLabel}${addressLineNum} ${isRequired}` },
                            onChange: (event) => {
                                this.handleInputChange({[str]: removeUnicodeControlCharacters(event.target.value)});
                            }
                        })
                    })
                }
                <SimpleDropdown
                    id={`select-country-${id}`}
                    value={country_code}
                    label={ t("address.addressform_country_label", "Country") }
                    boxClass='col-12 col-lg-8'
                    labelClass={labelClass}
                    onChange={
                        (event) => {
                            const {value} = event.target;
                            const cca2 = value === t("address.addressform_defaultoption_label", "Select an option") ? '' : value;
                            this.handleInputChange({
                                country_code: cca2,
                                state: '',
                                city: ''
                            });
                        }
                    }
                    data={this.props.countries}
                />
                { showStates &&
                    <SimpleDropdown
                        id={`select-states-${id}`}
                        value={state}
                        label={t("address.addressform_state_label", "State/ Province")}
                        boxClass='col-12 col-lg-8'
                        labelClass={labelClass}
                        onChange={(event) => {
                            const {value} = event.target;
                            const v   = value === t("address.addressform_defaultoption_label", "Select an option") ? '' : value;
                            this.handleInputChange({state: v});
                        }}
                        data={[{ label: '- Select -', value: '' }, ...this.props.states]}
                        areAddressDetailsValid={areAddressDetailsValid}
                        {...!state && { invalidFeedback: t("address.addressform_state_dropdown_error", "Please select.") }}
                    />
                }

                { showCities ?
                  showStates &&
                  <SimpleDropdown
                    id={`select-city-${id}`}
                    value={city}
                    label={t('address.addressform_city_label', 'City')}
                    boxClass='col-12 col-lg-8'
                    labelClass={labelClass}
                    onChange={(event) => {
                        const { value } = event.target;
                        const v = value === t('address.addressform_defaultoption_label', 'Select an option') ? '' : value;
                        this.handleInputChange({ city: v });
                    }}
                    data={[{ label: '- Select -', value: '' }, ...this.props.cities]}
                    areAddressDetailsValid={areAddressDetailsValid}
                    {...!city && { invalidFeedback: t("address.addressform_city_dropdown_error", "Please select.") }}
                  />
                  : this.renderInputfield({
                    id: `city-${id}`,
                    label: t('address.addressform_city_label', 'City'),
                    placeholder: t('address.addressform_city_placeholder', 'City'),
                    required,
                    disabled: showStates && !showCities && state === '',
                    maxLength: '30',
                    ...!city && { invalidFeedback: t('address.addressform_city_error', 'City is required.') },
                    onChange: (event) => {
                        this.handleInputChange({ city: removeUnicodeControlCharacters(event.target.value) });
                    },
                    value: city,
                    areAddressDetailsValid
                  })
                }
                {this.renderInputfield({
                    id: `postcode-${id}`,
                    label: t("address.addressform_postalcode_label", "Postcode"),
                    placeholder: t("address.addressform_postalcode_placeholder", "Postcode"),
                    value: postcode,
                    maxLength: '10',
                    required: postcodeIsRequired,
                    ...postcodeIsRequired && !postcode && { invalidFeedback: t("address.addressform_postalcode_error", "Postcode is required.") },
                    onChange: (event) => {
                        this.handleInputChange({postcode: event.target.value.replace(/[^a-zA-Z0-9]/g, '') });
                    },
                    areAddressDetailsValid: postCodeFieldValid
                })}
              <div style={{ display: hiddenPhoneField ? 'none' : '' }}>
                {showPhoneField &&
                this.renderInputfield({
                    id: `phone-${id}`,
                    label: t("address.addressform_phone_label", "Phone Number"),
                    placeholder: t("address.addressform_phone_placeholder", "0123456789"),
                    required,
                    maxLength: '15',
                    ...!telephone_number && { invalidFeedback: t("address.addressform_phone_error", "Phone number is required.") },
                    onChange: (event) => {
                      this.handleInputChange({telephone_number: event.target.value.replace(/\D/g, '') });
                    },
                    value: telephone_number
                })}
              </div>

              <div className={ areAddressDetailsValid ? 'd-none' : 'text-danger' }>
                <p>
                  {hasCityValidationError ?
                      t("address.previous_state_and_city_not_valid", "Your previous state and city are invalid, please choose the correct ones from the list.")
                    :
                    [(suggestedPostalCodeCombination === null || suggestedPostalCodeCombination.length == 0 ? 
                        t("address.postal_code_validation_no_matches", "We were unable to find a match based on the selected postal code and country. Please do consider reviewing it.")
                        : t("address.postal_code_validation_suggestion", "Suggested State, City & Postcode:")
                    )]
                  }
                </p>
                {suggestedPostalCodeCombination !== null ? suggestedPostalCodeCombination.map((suggestion, index) => {
                    let { postal_code: postCode, city_name: city, state_name: state } = suggestion;
                    return (<span key={`postal-code-combination-${index}`}><a>{state}, {city}, {postCode}</a><br/></span>);
                }) : ''}
                {suggestedPostalCodeCombination !== null && suggestedPostalCodeCombination.length > 0 ? <br /> : ''}

                {!hasCityValidationError
                 ? <HTMLTrans id="address.postal_code_validation_proceed">Please proceed to <strong>SAVE</strong> this address if you are sure that the information is correct</HTMLTrans>
                 : ''
                }
              </div>
            </div>
    );
  }
}

export const WithTitle = (WrappedComponent) => {
  return class AddressFormPropsProxy extends Component {
    render() {
      return (
        <div className='mt-2'>
            <p>{this.props.title}</p>
            <hr className='bg-gray-darken-1 mb-3'/>
        <WrappedComponent {...this.props}/>
      </div>
      );
    }
  };
};

const translated = withTranslation('address')(AddressForm);
export const AddressFormWithTitle = WithTitle(translated);
export default translated;
export const undecorated = AddressForm;



// WEBPACK FOOTER //
// ./src/Common/AddressForm.js